import allCases from '../../fields/cases/allCases';

export const QUERY_GET_ALL_GT_CASES = /* GraphQL */ `
	query($limit: Float, $offset: Float, $filter: GeneralTenantCaseFilter, $notEqual: GeneralTenantCaseFilter) {
		getAllGeneralTenantCase(
			limit: $limit
			offset: $offset
			filter: $filter
			notEqual: $notEqual
		) {
			items {
				${allCases}
				generalTenantCaseType
			}
			total
		}
	}
`;
